const e = "bc:";
function o(n) {
  return typeof n == "object" && n !== null && "type" in n && typeof n.type == "string" && n.type.startsWith(e);
}
function s(n) {
  window.parent && window.parent !== window && window.parent.postMessage(n, "*");
}
function i(n, t) {
  n.contentWindow?.postMessage(t, "*");
}
export {
  o as isBridgeMessage,
  i as postToIframe,
  s as postToParent
};
